import { type StatusPresentation, statusPresentation } from '@field-support/shared';
import { useTranslation } from 'react-i18next';
import { Badge } from './Badge';

export interface StatusBadgeProps<K extends string> {
  table: Record<K, StatusPresentation>;
  value: K | string;
  size?: 'sm' | 'md';
}

/**
 * Two-layer status presentation: the human label on scan surfaces, with the
 * exact token kept on `title` and `data-status` so it stays greppable.
 */
export function StatusBadge<K extends string>({ table, value, size = 'sm' }: StatusBadgeProps<K>) {
  const { i18n } = useTranslation();
  const entry = statusPresentation(table, value);
  return (
    <Badge tone={entry.tone} size={size} dot title={value} data-status={value}>
      {i18n.language === 'ar' ? entry.ar : entry.en}
    </Badge>
  );
}
